import request from '@/utils/request'

// 조회
export function getRiskAssessmentProcedure(params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getRiskAssessmentProcedureSample(isProgress) {
  return request({
    url: `/api/getRiskAssessmentProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function saveRiskAssessmentProcedure(params, isProgress) {
  return request({
    url: `/api/saveRiskAssessmentProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deleteRiskAssessmentProcedure(params, isProgress) {
  return request({
    url: `/api/deleteRiskAssessmentProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getRiskAssessmentProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getRiskAssessmentProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
